import { createRouterSelector } from '@atlassian/react-resource-router';
import { autoBeforeEachTest } from '@atlassian/jira-platform-auto-before-each-test/src/auto-before-each-test.tsx';
import { fg } from '@atlassian/jira-feature-gating';

/**
 * @deprecated only exposed for testing
 */
const useRouterRouteHydrationEnabled = createRouterSelector(
	(state) => state.route.isHydrateRootEnabled,
);

// eslint-disable-next-line camelcase
export { useRouterRouteHydrationEnabled as useRouterRouteHydrationEnabled__EXPOSED_FOR_TESTING_ONLY };

export function useIsPageHydrating(): boolean {
	if (!fg('jfp-magma-use-is-page-hydrating-hook')) {
		return false;
	}

	// eslint-disable-next-line react-hooks/react-compiler
	// eslint-disable-next-line react-hooks/rules-of-hooks
	const isRouteHydrationEnabled = useRouterRouteHydrationEnabled();
	if (fg('jfp-magma-force-react-hydrate-root')) {
		return true;
	}
	if (__SERVER__) {
		return isRouteHydrationEnabled ?? fg('hydrate-root-by-default');
	}
	return isPageHydratingClientSide;
}

let isPageHydratingClientSide = false;
export function setPageHydratingClientSide(): void {
	isPageHydratingClientSide = true;
}

autoBeforeEachTest(() => {
	isPageHydratingClientSide = false;
});
